export const myStatus = {
    myStatusIsOpen: false,
    activeStatus: '',
    statusList: {
        columnNames: [],
        numRows: 0,
        rowValues: []
    }
};
